import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
  container: {
    margin: '50px 0',
    '@media screen and (max-width: 600px)': {
      margin: '25px 0',
    },
    flex: '1 0 auto',
  },
  grid: {
    rowGap: 10,
    margin: 20,
  },
  childrenContainer: {},
}));

const BlockContainer = ({ children, style }) => {
  const classes = useStyles();
  return (
    <Container style={style} className={classes.container}>
      {children}
    </Container>
  );
};

export default BlockContainer;
